<section class="ids-mt-10">
  <div class="ids-px-5 text-center">
    <h1 class="ids-heading-xl max-width-38-rem">
      {{ error }}
    </h1>

    <p class="ids-mt-3">Felkod: {{ status }}</p>

    <div class="flex justify-center ids-mt-5">
      <id-button><button (click)="navigateToStart()">Återgå till start</button></id-button>
    </div>
  </div>
</section>
